(function () {
  if (window.PongbotProductPriceUpdater) return;

  var moneyFormat = document.documentElement.getAttribute('xo-money-format') || '{{amount}}';

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholderRegex);
    if (!match) return String(cents);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        return String(cents);
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  function refreshCurrencyConversion() {
    if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
      Currency.convertAll();
      return;
    }
    if (typeof window.Mlveda !== 'undefined' && typeof window.Mlveda.convertAll === 'function') {
      window.Mlveda.convertAll();
    }
  }

  function getVariantData(sectionEl, sectionId) {
    if (!sectionEl) return [];
    var el = sectionEl.querySelector('script[data-variant-json-' + sectionId + ']');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function setPriceElements(currentEl, compareEl, variant) {
    if (!variant) return;
    if (currentEl) {
      currentEl.innerHTML = formatMoney(variant.price);
      currentEl.classList.add('money');
    }
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.innerHTML = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
        compareEl.classList.add('money');
      } else {
        compareEl.style.display = 'none';
      }
    }
    refreshCurrencyConversion();
  }

  function updateSectionPrices(sectionId, variantId) {
    if (!sectionId || !variantId) return;

    var sectionEl = document.getElementById('shopify-section-' + sectionId)
      || document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!sectionEl) return;

    var variants = getVariantData(sectionEl, sectionId);
    var variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;

    var form = sectionEl.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      setPriceElements(
        form.querySelector('[data-custom-price="current"]'),
        form.querySelector('[data-custom-price="compare"]'),
        variant
      );
    }

    var stickyCart = document.querySelector('xo-sticky.xo-sticky-cart');
    if (stickyCart) {
      setPriceElements(
        stickyCart.querySelector('[data-sticky-price="current"]'),
        stickyCart.querySelector('[data-sticky-price="compare"]'),
        variant
      );
    }

    var priceWillChange = sectionEl.querySelector('xo-product-will-change[xo-unique-id^="product-price-"]');
    if (priceWillChange && typeof variant.price === 'number') {
      refreshCurrencyConversion();
    }
  }

  function syncAllSections() {
    document.querySelectorAll('[data-section-id][data-product-id]').forEach(function (wrapper) {
      var sectionId = wrapper.getAttribute('data-section-id');
      var checked = wrapper.closest('.shopify-section')
        ? wrapper.closest('.shopify-section').querySelector('.package-selector__radio-input:checked')
        : document.querySelector('.package-selector__radio-input:checked');
      var form = wrapper.querySelector('form[data-type="add-to-cart-form"]');
      var variantInput = form && form.querySelector('input[name="id"]');
      var variantId = (checked && checked.value) || (variantInput && variantInput.value);
      if (variantId) updateSectionPrices(sectionId, variantId);
    });
  }

  function handleVariantChange(variantId, sectionId) {
    if (sectionId) {
      updateSectionPrices(sectionId, variantId);
      return;
    }
    document.querySelectorAll('.shopify-section[id^="shopify-section-"]').forEach(function (sectionEl) {
      var id = sectionEl.id.replace('shopify-section-', '');
      updateSectionPrices(id, variantId);
    });
  }

  if (!window.__pongbotPriceListenersRegistered) {
    window.__pongbotPriceListenersRegistered = true;

    document.addEventListener('change', function (e) {
      if (e.target.matches('.package-selector__radio-input')) {
        var section = e.target.closest('.shopify-section');
        var sectionId = section ? section.id.replace('shopify-section-', '') : null;
        handleVariantChange(e.target.value, sectionId);
        return;
      }
      if (e.target.matches('form[data-type="add-to-cart-form"] input[name="id"]')) {
        var formSection = e.target.closest('.shopify-section');
        var formSectionId = formSection ? formSection.id.replace('shopify-section-', '') : null;
        handleVariantChange(e.target.value, formSectionId);
      }
    });

    document.addEventListener('custom:price:update', function (e) {
      var detail = e.detail || {};
      if (!detail.variantId) return;
      handleVariantChange(detail.variantId, detail.sectionId || null);
    });

    document.addEventListener('variant:change', function (e) {
      var detail = e.detail || {};
      var variantId = detail.variant && detail.variant.id;
      if (variantId) handleVariantChange(variantId, null);
    });

    document.addEventListener('app:product-page-loaded', function () {
      syncAllSections();
    });

    window.addEventListener('pongbot26:heavy-third-party-released', function () {
      syncAllSections();
    });
  }

  function initOnReady() {
    syncAllSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnReady);
  } else {
    initOnReady();
  }

  window.PongbotProductPriceUpdater = {
    updateSectionPrices: updateSectionPrices,
    syncAllSections: syncAllSections,
    refreshCurrencyConversion: refreshCurrencyConversion
  };
})();
